import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { BaseQLFieldDefinition } from '@adornis/baseql/metadata/types.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import type { AdornisUser } from '@adornis/users/db/a-user.js';

export type CustomFieldMapping = (
  field: BaseQLFieldDefinition,
  form: GenericFieldFormController<AdornisUser>,
) => Renderable | undefined;

@Entity()
export class GlobalConfig extends MongoEntity {
  static override _class = 'GlobalConfig';
  static override _collectionName = 'global-config';

  @Field(type => String) signupClosedNoteEnglish: Maybe<string>;
  @Field(type => String) signupClosedNoteGerman: Maybe<string>;

  @Field(type => String) imprint: Maybe<string>;
  @Field(type => String) dataPrivacy: Maybe<string>;
}

export const configRegistry = {
  fieldsOverride: null as null | ((userClass: typeof AdornisUser) => BaseQLFieldDefinition[]) | undefined,
  mentorCustomFieldMapping: null as null | CustomFieldMapping | undefined,
  menteeCustomFieldMapping: null as null | CustomFieldMapping | undefined,
};
